<template>
  <div class="flex justify-center">
    <nav
      class="flex fixed w-11/12 justify-between p-1 bg-bgnav z-20 text-center bottom-4 rounded-3xl shadow-md bg-theme-500"
      id="nav"
    >
      <div class="text-slate-200 mr-3">
        <router-link to="/profile" class="flex flex-col p-3">
          <font-awesome-icon icon="user" class="text-gray-300 fa-xl" />
        </router-link>
      </div>
      <div class="text-slate-200 mr-3">
        <router-link to="/menu" class="flex flex-col p-3">
          <font-awesome-icon icon="bars" class="text-gray-300 fa-xl" />
        </router-link>
      </div>
      <div class="text-slate-200 ml-3">
        <router-link to="/" class="flex flex-col p-3">
          <font-awesome-icon icon="house" class="text-gray-300 fa-xl" />
        </router-link>
      </div>
      <div class="relative text-theme-500">
        <a
          @click="getFactor()"
          class="flex flex-col p-3"
          data-intro="از این بخش میتوانید سبد خرید فعلی خود را مشاهده کنید و سفارش خود را نهایی کنید."
        >
          <span
            class="badge absolute -top-3 right-0 bg-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-theme-500"
            v-if="totalCount"
            >{{ totalCount }}</span
          >
          <font-awesome-icon icon="cart-shopping" class="text-gray-300 fa-xl" />
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getFinalFactor } from "@/API/API";

export default {
  name: "BottomNavigation",
  components: {  },
  computed: {
    ...mapGetters(["totalCount"]),
  },
  methods: {
    getFactor() {
      const result = this.$store.state.cart.products.map((a) => {
        return {
          kala: a.kala,
          kala_Name: a.kala_Name,
          quantity: a.quantity,
          sH_APPROVAL: a.sH_APPROVAL,
          anbar: a.anbar,
          takeout: 0,
          nerkh_With_Maliat: a.nerkh_With_Maliat,
          nerkh: a.nerkh,
          isNegative: a.isNegative,
          imgurl: a.imgurl,
          kasriType: a.kasriType,
          vahed: a.vahed,
          mojodi: a.mojodi,
          hacA08: a.hacA08,
          hacA12: a.hacA12,
          hasService: a.hasService,
          hasRace: a.hasRace,
          description: a.fullDescription,
          afzodeAvarez: a.afzodeAvarez,
          disRate: a.disRate,
        };
      });
      let factor = {
        sho_Mobile: "",
        discount: 0,
        locationCode: 0,
        tedad: 0,
        taF_NAME: "",
        orderType: "restaurant",
        desK_NUMBER: 0,
        deliveryDelay: "",
        goods: result,
        companions: "",
        factoR_ID: 0,
        payed: "",
        printeR_PORTABLE: "",
        printeR_KITCHEN: "",
        printeR_CASH: "",
        captaiN_ID: "",
        prinT_STATUS: "",
        paymenT_STATUS: "",
        saloonID: "",
        saloonName: "",
        mobile: "",
        description: "",
        maliat: 0,
        maB_WITH_MALIAT: 0,
        timE_FACTOR: "",
        datE_FACTOR: "",
        prinT_STATUS_CODE: 0,
        pardakhT_STATUS: "",
        pardakhT_STATUS_CODE: 0,
        iranI_STATUS: "",
        farangI_STATUS: "",
        paymentType: "",
        iranI_STATUS_CODE: 0,
        farangI_STATUS_Code: 0,
        paymessage: "",
        systemGOODS: [],
      };
      getFinalFactor(factor)
        .then((resp) => {
          this.$store.dispatch("setNewFactorSum", resp.data.result.factorSum);
          this.$store.dispatch("setNewFactorHsale", resp.data.result.hsale);
        })
        .catch((err) => {
          console.log(err);
        });
      this.$cart.value = true;
    },
  },
};
</script>

<style scoped>
.router-link-active {
  @apply bg-bgbacknav rounded-full  text-slate-200 shadow-sm;
}
</style>
